import { dashedToCamelCase, capitalize } from 'src/js/modules/utils/convert-case';

const generateModifiedEventTraits = (prefixPart, mainPart, oldValue, newValue) => {
  const prefix = dashedToCamelCase(prefixPart);
  const main = capitalize(dashedToCamelCase(mainPart));
  const oldValueTraitName = `${prefix}${main}OldValue`;
  const newValueTraitName = `${prefix}${main}NewValue`;

  return {
    [oldValueTraitName]: oldValue || null,
    [newValueTraitName]: newValue,
  };
};

export default generateModifiedEventTraits;
